import React, { FC } from 'react';
import Alert from '@mui/material/Alert';
import translate from '@translate';
import { useArchiveMode } from 'src/utils/archiveMode';

/** Read-only banner shown on detail pages opened in archive mode (`?archive=1`). */
const ArchiveBanner: FC = () => {
    const archive = useArchiveMode();
    if (!archive) {
        return null;
    }
    return (
        <Alert severity="info" sx={{ marginBottom: 2 }} data-testid="archive-banner">
            {translate('archive.banner')}
        </Alert>
    );
};

export default ArchiveBanner;
